<main class="main">
  <mat-progress-bar
    *ngIf="isLoading$ | async"
    class="app-progress-bar position-fixed"
    mode="indeterminate"
  ></mat-progress-bar>
  <app-toolbar *ngIf="!(hideToolbar || isIframe)"></app-toolbar>
  <app-page-header [hidden]="hidePageHeader"></app-page-header>
  <router-outlet />
</main>

<app-screen-lock />
